var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user_auth" }, [
    _c("form", { staticClass: "user" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("b-form-input", {
            staticClass: "form-control form-control-user",
            attrs: {
              state: _vm.username_state,
              id: "input-live-feedback",
              placeholder: "USER"
            },
            model: {
              value: _vm.user_form.username,
              callback: function($$v) {
                _vm.$set(_vm.user_form, "username", $$v)
              },
              expression: "user_form.username"
            }
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { id: "input-live-feedback" } },
            [_vm._v("\n                Минимум 3 символа\n            ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("b-form-input", {
            staticClass: "form-control form-control-user",
            attrs: {
              state: _vm.userpass_state,
              id: "user_pass",
              type: "password",
              placeholder: "Password"
            },
            model: {
              value: _vm.user_form.password,
              callback: function($$v) {
                _vm.$set(_vm.user_form, "password", $$v)
              },
              expression: "user_form.password"
            }
          }),
          _vm._v(" "),
          _c("b-form-invalid-feedback", { attrs: { id: "user_pass" } }, [
            _vm._v("\n                Минимум 6 символов\n            ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "b-button",
            {
              staticClass: "btn btn-warning btn-user btn-block",
              attrs: { disabled: !_vm.is_disabled },
              on: { click: _vm.make_auth }
            },
            [_vm._v("Вход")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }